module.exports = __webpack_public_path__ + "media/images/avatar/development/nannies/18-b69c9543084bf3a5a7738007df563b48.jpg";